import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { CreateKentRebalancingScheduleRequest } from '@cast/types-kent';

import { getClusterRebalancingSchedulesQueryKey } from 'hooks/queries/kent/useGetClusterRebalancingSchedules';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type RequestParams = Omit<
  CreateKentRebalancingScheduleRequest,
  'organizationId'
>;

export const useCreateRebalancingScheduleMutation = () => {
  const { currentOrganization } = useOrganizations();
  const organizationId = currentOrganization!.id;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      clusterId,
      createRebalancingScheduleData,
    }: RequestParams) => {
      return apiClient.kent.createRebalancingSchedule({
        organizationId,
        clusterId,
        createRebalancingScheduleData,
      });
    },

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getClusterRebalancingSchedulesQueryKey(variables.clusterId),
      });
    },
    onError: (error) => {
      notify.error(
        `Failed to create rebalancing schedule: ${parseApiError(error)}`
      );
    },
  });
};
